import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IClimateTemperatureChartProps {
  control: IControl;
  width: number;
  height: number;
}

const ClimateTemperatureChart = (props: IClimateTemperatureChartProps) => {
  const { control, width, height } = props;
  const { value, valuesList } = useControlMeasurements(control, ["temp_dht22"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    const colorList = ["#ff0000"];
    chart.drawLines(ctx, valuesList, colorList, "°C");
  };

  return (
    <MeasurementChart
      title={t("Temperature") + ` ${value}°C`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default ClimateTemperatureChart;
